module.exports = __webpack_public_path__ + "img/moses-yale-beach.1cf62c38.png";